/* eslint-disable no-shadow */ 

import React, { useEffect, useState } from 'react';
import { Container } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import Breadcrumbs from 'components_newui/pageBreadcrumbsMenu/View';
import NxtCircularLoader from 'components/nxt_circular_loader/View';
import { FIRST_LIMIT_CONSTANT, LIMIT_CONSTANT } from '../../common_constants/Ideas'
import ChallengeList from './ChallengeList';
import ChallengeFilters from './ChallengeFilters';
import EmptyState from './EmptyState';
import LoadMoreButton from './LoadMoreButton';
import styles from './View.Style';
import RenderInnovateChallenge from './RenderInnovateChallenge';

const ACTIVE_CHALLENGES = 'ACTIVE';
const EXPIRED_CHALLENGES = 'FINISHED';

const Challenges = props => {
  const {
    classes,
    challengesAll,
    getActiveChallenges,
    challengesFilter,
    isAdmin,
    hasMoreChallengeToLoad,
    challengeIdeasLoading,
    canProposeChallenge,
    isInnovator,
    localAdmin,
    navigateToChallengeDetail,
    getFilteredChallenges,
    navigateToExplore,
    enableIsHackathon,
    listInnovateChallengeLoading,
    getInnovateChallengeActiveTypes,
    getInnovateChallengeAllListFn,
    getInnovateChallengeFilterListFn,
    filterListInnovateChallenge,
    filterListInnovateChallengeLoading,
    listInnovateChallenge,
    innovateCategoryTypes,
    filterListInnovateChallengeTotal,
  } = props;

  const [offset, setOffset] = useState(0);
  const [challengeStatus, setChallengeStatus] = useState(ACTIVE_CHALLENGES);
  const [challengeAllData, setChallengeAllData] = useState([]);
  const [activeFilters, setActiveFilters] = useState({ status: [] });
  const [nameQuery, setNameQuery] = useState('');

  const pageHierarchy = [
    { string: 'Home', navigate: navigateToExplore },
    { string: 'All challenges', navigate: () => {} },
  ];

  // Fetch innovate challenges if hackathon is enabled
  useEffect(() => {
    if (enableIsHackathon) {
      // getInnovateChallengeAllListFn?.();

      // getInnovateChallengeFilterListFn(ACTIVE_CHALLENGES, enableIsHackathon)
      getInnovateChallengeActiveTypes?.();
    }
  }, [enableIsHackathon]);

  //  useEffect(()=>{
  //   if(!enableIsHackathon){
  //     getActiveChallenges()
  //   }
  // },[enableIsHackathon])

  useEffect(()=>{
      setChallengeAllData(challengesAll)
  },[challengesAll])



 // Reset offset and fetch challenges when status changes
    useEffect(() => {
        
       if(!enableIsHackathon){
        getFilteredChallenges(challengeStatus, 0, FIRST_LIMIT_CONSTANT, enableIsHackathon);
        setOffset(0);
        }
      }, [challengeStatus,enableIsHackathon]);
    

  const handleFilterChange = e => setChallengeStatus(e.target.value);

 const handleOnLoadMore = () => {
    const currentOffset = offset || 0;
    console.log('offset',offset)
    const newLimit = currentOffset ? LIMIT_CONSTANT : FIRST_LIMIT_CONSTANT
    const newOffset = newLimit + currentOffset
  
    // Call API with current offset and limit
    getFilteredChallenges(
      challengeStatus,
      newOffset,
      LIMIT_CONSTANT,
      enableIsHackathon,
    );
  
    // Update offset for next call
    setOffset(newOffset);
  };

  const applySearch = () => {
    const filtered = challengeAllData.filter(item =>
      item.title?.toLowerCase().includes(nameQuery.toLowerCase())
    );
    setChallengeAllData(filtered);
  };

  const resetSearch = () => {
    setNameQuery('');
    setChallengeAllData(challengesAll);
  };

  const sortedFiltered = React.useMemo(() => {
    return [...challengeAllData].sort(
      (a, b) => (b?.starts?.timestamp ?? 0) - (a?.starts?.timestamp ?? 0)
    );
  }, [challengeAllData]);
  
  return (
    <>
      <Breadcrumbs crumbs={pageHierarchy} />
      <Container>
        {!enableIsHackathon ? (
          <div className={classes.background}>
            <div className={classes.content_container}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className={classes.title}>
                  <span>All Challenge ({challengeAllData?.length})</span>
                </div>
              </div>

             <ChallengeFilters
                activeFilters={activeFilters}
                setActiveFilters={setActiveFilters}
                nameQuery={nameQuery}
                setNameQuery={setNameQuery}
                applySearch={applySearch}
                resetSearch={resetSearch}
                challengeStatus={challengeStatus}
                handleFilterChange={handleFilterChange}
                isAdmin={isAdmin}
                isInnovator={isInnovator}
                localAdmin={localAdmin}
                classes={classes}
              />

              <NxtCircularLoader isLoading={challengeIdeasLoading}>
                {challengeAllData?.length === 0 ? (
                  <EmptyState classes={classes} />
                ) : (
                  <ChallengeList
                    challenges={sortedFiltered}
                    onClick={navigateToChallengeDetail}
                    classes={classes}
                  />
                )}

                {hasMoreChallengeToLoad && (
                  <LoadMoreButton onClick={handleOnLoadMore} classes={classes} />
                )}
              </NxtCircularLoader>
            </div>
          </div>
        ) : (
          <NxtCircularLoader isLoading={filterListInnovateChallengeLoading}>
            <RenderInnovateChallenge
              isAdmin={isAdmin}
              isInnovator={isInnovator}

              getInnovateChallengeFilterListFn={getInnovateChallengeFilterListFn}
              listInnovateChallengeData={filterListInnovateChallenge}
              innovateCategoryTypes={innovateCategoryTypes}
              enableIsHackathon={enableIsHackathon}
              filterListInnovateChallengeTotal={filterListInnovateChallengeTotal}
            />
          </NxtCircularLoader>
        )}
      </Container>
    </>
  );
};

Challenges.propTypes = {
  // Add prop types here if needed
};

export default withStyles(styles)(Challenges);
